import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagNF = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M35.87 2.48A24.9 24.9 0 0 0 25 0a24.9 24.9 0 0 0-10.869 2.48L11.957 25l2.174 22.519a24.9 24.9 0 0 0 10.87 2.48 24.9 24.9 0 0 0 10.869-2.48l2.174-22.52L35.87 2.482Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M14.13 2.481C5.768 6.525 0 15.088 0 25c0 9.912 5.768 18.475 14.13 22.518V2.481ZM35.87 2.481v45.036C44.232 43.474 50 34.911 50 25c0-9.911-5.768-18.474-14.13-22.518ZM31.522 32.607 25 11.955 18.48 32.607h4.89v5.435h3.262v-5.435h4.89Z"
}));
FlagNF.displayName = 'FlagNF';
export default withFlagWrapper(FlagNF);
//# sourceMappingURL=index.js.map